






import Vue from 'vue'
import { Chart, ChartConfiguration, ChartData } from 'chart.js'
import { ArcDataTab } from '@/config/interfaces'

export default Vue.extend({
  name: 'ArcChart',

  data: () => ({
    options: {
      circumference: 4.189, // 240 * (Math.PI / 180) - Must be in radians
      rotation: 2.618, // 150 * (Math.PI / 180) - Must be in radians
      cutoutPercentage: 88, // Controls the doughnut thickness
      responsive: true,
      maintainAspectRatio: true
    }
  }),

  mounted () {
    this.createChart()
  },

  watch: {
    // Watch for changes on 'arcData' prop
    arcData: function () {
      this.createChart()
    }
  },

  computed: {
    bottomChartPadding (): number {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 10
      }
      return 15
    }
  },

  methods: {
    createChart (): Chart {
      const canvas = this.$refs.dataChart as HTMLCanvasElement

      const chartOptions = {
        ...this.options,
        layout: {
          padding: {
            top: -10,
            left: -10,
            right: -10,
            bottom: this.bottomChartPadding
          }
        }
      }

      const options = {
        type: 'roundedDoughnut',
        data: this.getChartData(),
        options: chartOptions
      } as ChartConfiguration

      return new Chart(canvas, options)
    },
    getChartData (): ChartData {
      return {
        datasets: [
          {
            data: this.$props.arcData.map((e: ArcDataTab) => e.val),
            backgroundColor: this.$props.arcData.map((e: ArcDataTab) => e.color),
            borderWidth: 0
          }
        ]
      }
    }
  },

  props: {
    arcData: {
      type: Array as () => Array<ArcDataTab>,
      required: true
    }
  }
})
